import { UserRole } from '@/apolloClient.types';
import { useActiveRole, useUser } from '@/contexts/UserSession';

const useCompanyManagementAbilities = () => {
    const user = useUser(true);
    const activeRole = useActiveRole();
    const role = activeRole?.role || null;
    const company = user.__typename === 'TenantUser' ? user.company : null;

    const canViewOwnCompanyDetails = () => {
        return !!company && role === UserRole.CompanyAdmin;
    };

    const canEditCompany = (companyId: string) => {
        return !!company && company.id === companyId && role === UserRole.CompanyAdmin;
    };

    return {
        canViewOwnCompanyDetails,
        canEditCompany,
    };
};

export type CompanyManagementAbilities = ReturnType<typeof useCompanyManagementAbilities>;
export default useCompanyManagementAbilities;
